/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_Offerstooltip1Inputs */

const id_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran adalah item yang dapat dibeli dari toko`)
};

const ms_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran ialah item boleh beli dari kedai`)
};

const da_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et tilbud er en køb vare fra butikken`)
};

const de_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Angebot ist ein kaufbarer Gegenstand aus dem Store`)
};

const en_us2_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An offer is a purchasable item from the store`)
};

const es_es2_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una oferta es un item de catálogo comprable de la tienda`)
};

const es_mx2_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una oferta es un artículo comprable de la tienda`)
};

const fil_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang offer ay isang mabibiling item mula sa tindahan`)
};

const fr_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une offre est un item de catalogue achetable dans la boutique`)
};

const it_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'offerta è un articolo acquistabile dal negozio`)
};

const hu_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az ajánlat egy megvásárolható elem az áruházból`)
};

const nl_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een aanbod is een aankoopbaar item uit de winkel`)
};

const no_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et tilbud er en kjøpbar vare fra butikken`)
};

const pl_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta to kupowany element z katalogu sklepu`)
};

const pt_br2_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers tooltip`)
};

const pt_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma oferta é um item de catálogo comprável na loja`)
};

const ro_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ofertă este un element de catalog cumpărabil din magazin`)
};

const fi_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjous on ostettava katalogikohde kaupasta`)
};

const sv_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett erbjudande är ett köpbart katalogobjekt från butiken`)
};

const vi_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một ưu đãi là một mục có thể mua được từ cửa hàng`)
};

const tr_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif, mağazadan satın alınabilir bir öğedir`)
};

const cs_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídka je zakoupitelná položka z obchodu`)
};

const bg_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Офертата е закупуем обект от магазина`)
};

const ru_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложение — это покупаемый объект из магазина`)
};

const uk_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозиція — це товар, який можна придбати в магазині`)
};

const ar_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العرض هو عنصر قابل للشراء من المتجر`)
};

const hi_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र स्टोर से खरीदी जा सकने वाली वस्तु है`)
};

const th_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอคือสินค้าที่สามารถซื้อได้จากร้านค้า`)
};

const ja_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーはストアから購入可能なアイテムです`)
};

const zh_cn2_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers tooltip`)
};

const zh_hant1_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers tooltip`)
};

const ko_components_stats_offerstooltip1 = /** @type {(inputs: Components_Stats_Offerstooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers tooltip`)
};

/**
* | output |
* | --- |
* | "An offer is a purchasable item from the store" |
*
* @param {Components_Stats_Offerstooltip1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_offerstooltip1 = /** @type {((inputs?: Components_Stats_Offerstooltip1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_Offerstooltip1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_offerstooltip1(inputs)
	if (locale === "ms") return ms_components_stats_offerstooltip1(inputs)
	if (locale === "da") return da_components_stats_offerstooltip1(inputs)
	if (locale === "de") return de_components_stats_offerstooltip1(inputs)
	if (locale === "en-US") return en_us2_components_stats_offerstooltip1(inputs)
	if (locale === "es-ES") return es_es2_components_stats_offerstooltip1(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_offerstooltip1(inputs)
	if (locale === "fil") return fil_components_stats_offerstooltip1(inputs)
	if (locale === "fr") return fr_components_stats_offerstooltip1(inputs)
	if (locale === "it") return it_components_stats_offerstooltip1(inputs)
	if (locale === "hu") return hu_components_stats_offerstooltip1(inputs)
	if (locale === "nl") return nl_components_stats_offerstooltip1(inputs)
	if (locale === "no") return no_components_stats_offerstooltip1(inputs)
	if (locale === "pl") return pl_components_stats_offerstooltip1(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_offerstooltip1(inputs)
	if (locale === "pt") return pt_components_stats_offerstooltip1(inputs)
	if (locale === "ro") return ro_components_stats_offerstooltip1(inputs)
	if (locale === "fi") return fi_components_stats_offerstooltip1(inputs)
	if (locale === "sv") return sv_components_stats_offerstooltip1(inputs)
	if (locale === "vi") return vi_components_stats_offerstooltip1(inputs)
	if (locale === "tr") return tr_components_stats_offerstooltip1(inputs)
	if (locale === "cs") return cs_components_stats_offerstooltip1(inputs)
	if (locale === "bg") return bg_components_stats_offerstooltip1(inputs)
	if (locale === "ru") return ru_components_stats_offerstooltip1(inputs)
	if (locale === "uk") return uk_components_stats_offerstooltip1(inputs)
	if (locale === "ar") return ar_components_stats_offerstooltip1(inputs)
	if (locale === "hi") return hi_components_stats_offerstooltip1(inputs)
	if (locale === "th") return th_components_stats_offerstooltip1(inputs)
	if (locale === "ja") return ja_components_stats_offerstooltip1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_offerstooltip1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_offerstooltip1(inputs)
	return ko_components_stats_offerstooltip1(inputs)
});
export { components_stats_offerstooltip1 as "components.stats.offersTooltip" }